// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';

export const resetConfirmationModal = () => ({
    type: actions.RESET_CLAIM_MCC_FOLLOWUP_CONFIRMATION_MODAL
});

export const updateConfirmationModal = options => ({
    data: options,
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_CONFIRMATION_MODAL
});



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/confirmation-modal.js